export default __webpack_public_path__ + "d0fb63c7f6cb337ed39cc1c5e22f0b35.svg";